"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddItemPriceOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var AddItemPriceOutputWidget = /** @class */ (function (_super) {
    __extends(AddItemPriceOutputWidget, _super);
    function AddItemPriceOutputWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddItemPriceOutputWidget.prototype.render = function () {
        var _this = this;
        var newItems = this.props.interaction.valuableItems.filter(function (item) { return !(_this.props.interaction.uistate.itemIds && _this.props.interaction.uistate.itemIds.includes(item.valuableItemId)); });
        window.sessionStorage.removeItem("mtaAddItemDescriptions");
        window.sessionStorage.setItem("mtaAddItemDescriptions", JSON.stringify(newItems.map(function (item) { return item.description; })));
        return ((0, jsx_runtime_1.jsxs)("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center", children: [(0, jsx_runtime_1.jsx)("div", { id: "price", className: "fs-24 letter-spacing-n35 font-weight-bold font-family-display mb-2", children: (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.additionalPremium) }), (0, jsx_runtime_1.jsxs)("div", { children: __spreadArray(["to add"], newItems.map(function (item, index, array) {
                        if (index === array.length - 1) {
                            return (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsxs)("b", { className: "font-weight-semi-bold", children: [" ", item.description] }) }, index);
                        }
                        return (0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsxs)("b", { className: "font-weight-semi-bold", children: [" ", item.description] }), " and"] }, index);
                    }), true) })] }));
    };
    return AddItemPriceOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.AddItemPriceOutputWidget = AddItemPriceOutputWidget;
//# sourceMappingURL=AddItemPriceOutputWidget.js.map